// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"26b924e4b0620d6d022c","768":"42c5b154cc0a931e5a72","983":"3d8b2de3512d9113f4bf"}[chunkId] + ".js";
};